import { Route } from 'react-router-dom';

import Login from '../component/login/Login';
// Hidden for now, see the ACCOUNT Route below: import { AccountPage } from '../component/page/account/AccountPage';
import { AdminPanel } from '../component/page/admin-panel/AdminPanel';
import CartPage from '../component/page/cart/CartPage';
import { ConsultantSignPage } from '../component/page/consultant-sign/ConsultantSignPage';
import Menu from '../component/page/menu/Menu';
import { MenuItemPage } from '../component/page/menu/item/MenuItemPage';
import NotFound from '../component/page/not-found/NotFound';
import { OrderSearchPage } from '../component/page/order-search/OrderSearchPage';
import Orders from '../component/page/orders/Orders';
import { PrivacyPolicy } from '../component/page/privacy-policy/PrivacyPolicy';
import { TermsAndConditions } from '../component/page/terms-and-conditions/TermsAndConditions';

import AdminRoute from './AdminRoute';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import { ROUTE_PATH } from './utils';

export const appRoutes = () => (
  <Route errorElement={<NotFound />} path="/">
    <Route
      exact
      path={ROUTE_PATH.MENU}
      element={
        <PublicRoute>
          <Menu />
        </PublicRoute>
      }
    />
    <Route
      path={`${ROUTE_PATH.MENU_ITEM}/:menuItemId`}
      element={
        <PublicRoute>
          <MenuItemPage />
        </PublicRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.CART}
      element={
        <PublicRoute>
          <CartPage />
        </PublicRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.ORDERS}
      element={
        <ProtectedRoute>
          <Orders />
        </ProtectedRoute>
      }
    />
    {/* Hidden for now:
    <Route
      exact
      path={ROUTE_PATH.ACCOUNT}
      element={
        <ProtectedRoute>
          <AccountPage />
        </ProtectedRoute>
      }
    />
    */}
    <Route
      exact
      path={ROUTE_PATH.ADMIN_PANEL}
      element={
        <AdminRoute>
          <AdminPanel />
        </AdminRoute>
      }
    />
    <Route
      path={`${ROUTE_PATH.ORDER}/:orderNumber?`}
      element={
        <AdminRoute>
          <OrderSearchPage />
        </AdminRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.PRIVACY_POLICY}
      element={
        <PublicRoute>
          <PrivacyPolicy />
        </PublicRoute>
      }
    />
    <Route
      exact
      path={ROUTE_PATH.TERMS_AND_CONDITIONS}
      element={
        <PublicRoute>
          <TermsAndConditions />
        </PublicRoute>
      }
    />
    <Route exact path={ROUTE_PATH.LOGIN} element={<Login />} />
    <Route path={`${ROUTE_PATH.CONSULTANT_SIGN}/:token`} element={<ConsultantSignPage />} />
  </Route>
);
